import type { RouteRecordRaw } from 'vue-router'

import { SHOPPING_ASSISTANT, SHOPPING_ASSISTANT_NEW } from './routes.constants'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'assistant/new',
      name: SHOPPING_ASSISTANT_NEW,
      component: () =>
        import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
      meta: {
        layout: 'webview-default',
        shouldDisplayEdgeToEdge: true,
        owners: ['bot-group-ai-shopping-assistant-front'],
        tracking: { contentGroup: 'AI Assistant' },
      },
    },
    {
      path: 'assistant/:chatId?',
      name: SHOPPING_ASSISTANT,
      component: () =>
        import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
      meta: {
        layout: 'webview-default',
        shouldDisplayEdgeToEdge: true,
        owners: ['bot-group-ai-shopping-assistant-front'],
        tracking: { contentGroup: 'AI Assistant' },
      },
    },
  ]
}
